var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep4Current(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 68,
    cy: 68,
    r: 68,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 68,
    cy: 68,
    r: 62,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 124C98.9279 124 124 98.9279 124 68C124 37.0721 98.9279 12 68 12C37.0721 12 12 37.0721 12 68C12 98.9279 37.0721 124 68 124Z",
    fill: "#DA5042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.313 48.0126L75.9536 34.1868L52.2991 69.0195L72.6585 82.8453L96.313 48.0126Z",
    fill: "#302322"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4229 76.7965L60.5835 73.5101L52.207 85.8451L57.0464 89.1315L65.4229 76.7965Z",
    fill: "#EEC98A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4685 103.569L42.1967 100.657C41.9847 100.51 41.828 100.296 41.7516 100.05C41.6751 99.8032 41.6834 99.5382 41.775 99.2969L48.2098 83.2303C48.2708 83.0715 48.3667 82.9286 48.4906 82.8122C48.6145 82.6957 48.763 82.6088 48.9252 82.5578C49.0874 82.5068 49.259 82.493 49.4272 82.5176C49.5954 82.5422 49.756 82.6044 49.8968 82.6997L60.3857 89.8283C60.5254 89.9251 60.6417 90.0517 60.7263 90.1991C60.8109 90.3465 60.8615 90.5108 60.8746 90.6802C60.8876 90.8497 60.8627 91.0198 60.8016 91.1784C60.7406 91.337 60.645 91.4799 60.5217 91.5969L47.9377 103.46C47.7424 103.644 47.4899 103.755 47.2224 103.775C46.9549 103.794 46.6888 103.722 46.4685 103.569Z",
    fill: "#EEC98A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.503 43.732L78.3989 28.7215C76.3974 27.3623 73.6748 27.8805 72.3177 29.8788C70.9607 31.8772 71.4831 34.599 73.4845 35.9581L95.5884 50.9686C97.5898 52.3278 100.312 51.8096 101.669 49.8113C103.027 47.8129 102.504 45.0911 100.503 43.732Z",
    fill: "#302322"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6404 77.3793L55.5365 62.3688C53.5351 61.0097 50.8125 61.5278 49.4554 63.5262C48.0984 65.5245 48.6208 68.2463 50.6222 69.6055L72.7261 84.616C74.7275 85.9751 77.4501 85.457 78.8072 83.4586C80.1642 81.4603 79.6418 78.7385 77.6404 77.3793Z",
    fill: "#302322"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0852 46.4846C79.5621 45.7823 79.3794 44.8262 78.677 44.3492C77.9747 43.8723 77.0186 44.055 76.5416 44.7574L64.3131 62.7646C63.8362 63.4669 64.0189 64.423 64.7213 64.9C65.4236 65.3769 66.3797 65.1942 66.8567 64.4918L79.0852 46.4846Z",
    fill: "#C2D3DF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3405 51.3889C86.8175 50.6866 86.6348 49.7305 85.9324 49.2535C85.23 48.7766 84.274 48.9593 83.797 49.6617L71.5685 67.6689C71.0915 68.3712 71.2743 69.3273 71.9766 69.8043C72.679 70.2812 73.6351 70.0985 74.112 69.3961L86.3405 51.3889Z",
    fill: "#C2D3DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4Current);
export default __webpack_public_path__ + "static/media/step4-current.718d436c7a427e290e1db8f66b62ff9a.svg";
export { ForwardRef as ReactComponent };